import Img from "gatsby-image";
import {Link,graphql} from "gatsby";
import React from "react";

import Parser from 'html-react-parser';

class MainSpotlightSection extends React.Component {

    constructor(props) {
        super(props)
    }

    render() {
        const {fields,slug,orientation,first} = this.props
        let orientationPos = orientation || "right"
        return (
            <section
                className={`spotlight style1 orient-${orientationPos} content-align-left image-position-center onscroll-image-fade-in`}>
                <div className="content">
                    <h2>{fields.title.text}</h2>
                    {Parser(fields.subtitle.html)}
                    <ul className="actions stacked">
                        <li><Link className="button" to={`/blog/${slug}`}>Leggi tutto</Link></li>
                    </ul>
                </div>
                <div className="image">
                {fields.image.localFile != null ? (
                    <Link to={`/blog/${slug}`}>
                        <Img fluid={fields.image.localFile.childImageSharp.fluid}/>
                    </Link>
                ) : ''}
                </div>
            </section>
        )
    }
}

export default MainSpotlightSection